<div class="chart-container">
    <canvas id="{{mychart}}">{{ chart }}</canvas>
</div>